@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-box-group-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.boxGroupContext"
                [box]="_context.boxGroupContext.item"
                (boxUpdated)="onBoxGroupUpdated($event)"
                (canceled)="onCanceled($event)"></app-box-group-form>
        </mat-tab>
        @if (!!_context.boxGroupContext.item.id) {
            <mat-tab label="bannettes">
                <app-boxes-form [context]="_context.boxGroupContext" (boxesUpdated)="onBoxesUpdated($event)" (canceled)="onCanceled($event)"></app-boxes-form>
            </mat-tab>
        }
    </mat-tab-group>
}
